// Carries a message across a full-page navigation, where a toast raised before the redirect dies
// with the document. The URL carries a KEY, never the text: free text rendered as a system toast
// on an unauthenticated page is a phishing channel — a link to the genuine CRM, real origin, real
// certificate, saying "your account is locked, call 855-000-0000" in the application's own voice.
// Severity travels with the key for the same reason.
export const SIGN_IN_NOTICES = {
  'password-set': {
    severity: 'success',
    text: 'Your password is set. Please sign in to continue.',
  },
  // Same email on two live accounts: the password IS set, but no sign-in can pick between them,
  // so promising "please sign in to continue" would send the user into a loop with no way out.
  'password-set-contact-admin': {
    severity: 'error',
    text: 'Your password is set, but more than one account uses this email, so we cannot sign you in. Please contact your administrator.',
  },
  'password-reset': {
    severity: 'success',
    text: 'Your password has been changed. Please sign in with your new password.',
  },
}

// Own keys only. A plain lookup answers `constructor` and `toString` from Object.prototype, so a
// crafted parameter would hand a function to the toast instead of falling through to null.
export const noticeFor = (key) => (
  Object.prototype.hasOwnProperty.call(SIGN_IN_NOTICES, key) ? SIGN_IN_NOTICES[key] : null
)
